export default __webpack_public_path__ + "static/media/FS-HOME-ACERCA-IMAGEN.99df2c2b.png";